var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZoomIn = function SvgZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zoomIn_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.087,
    cy: 9.826,
    r: 5.712,
    stroke: "#1A1E2C",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1E2C",
    strokeWidth: 0.75,
    d: "m14.396 14.431 4.869 4.869"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 10a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5Z",
    fill: "#1A1E2C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 7.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V8a.5.5 0 0 1 .5-.5Z",
    fill: "#1A1E2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zoomIn_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgZoomIn;